export const convertToAM_PM = (time24: string) => {
  if (time24) {
    let [hours, minutes] = time24.split(':').map(Number);
    let period = 'AM';

    if (hours >= 12) {
      period = 'PM';
      if (hours > 12) {
        hours -= 12;
      }
    }

    return `${hours}:${minutes} ${period}`;
  }
};
